import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../../../assests/css/admin/UserManagement/TeacherManagement.css";
import { AppContext } from "../../../context/Appcontext";
import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";
import { Badge, Spinner } from "react-bootstrap";

const TeacherAdd = ({ onBack, onSave }) => {
  const { baseUrl, regExpChecker } = useContext(AppContext);
  const [fullname, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [departments, setDepartments] = useState([]);
  const [Programmes, setProgrammes] = useState([]);
  const [Programme, setProgramme] = useState("");
  const [department, setDepartment] = useState("");

  const [status, setStatus] = useState("Active");
  const [courses, setCourses] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false); // Add/Update button spinner

  const viewAllDepartments = () => {
    axios
      .get(`${baseUrl}/admin/department/viewAllDepartments`)
      .then((response) => {
        console.log(response.data);
        setDepartments(response.data.departments);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllDepartments();
  }, []);

  const handleCourseCheckbox = (courseId) => {
    setSelectedCourses((prev) =>
      prev.includes(courseId)
        ? prev.filter((id) => id !== courseId)
        : [...prev, courseId],
    );
  };

  const validateForm = () => {
    let newErrors = {};
    if (!fullname.trim()) newErrors.fullname = "Full name is required.";
    if (!email.trim()) newErrors.email = "Email is required.";
    if (!password.trim()) newErrors.password = "Password is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const createTeacher = () => {
    const formData = new FormData();
    formData.append("fullname", fullname);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("ngdepartment_id", department);
    formData.append("ngprogramme_id", Programme);
   
    formData.append("status", status);

    formData.append("courses", selectedCourses.toString()); // ✅ sirf ek baar
    // selectedCourses.forEach((id) => formData.append('courses', id));

    setIsSubmitting(true);
    axios
      .post(`${baseUrl}/admin/user/createTeacher`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        if (onSave) onSave();
        if (onBack) onBack();
      })
      .catch((error) => {
        alert(error?.response?.data?.message || "Something went wrong");
      });
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    createTeacher();
  };

  return (
    <div className="sam-wrapper">
      <div className="sam-container">
        <button className="sam-back-link" onClick={onBack}>
          &#8592; Back to List
        </button>
        <div className="sam-card">
          <div className="sam-page-header">
            <h2 className="sam-page-title">Add Teacher</h2>
            <p className="sam-page-subtitle">
              Fill in the details to register a new teacher.
            </p>
          </div>
          <hr className="sam-divider" />
          <div className="sam-form">
            {/* Full Name */}
            <div className="sam-form-group">
              <label className="sam-label">Full Name</label>
              <input
                className="sam-input"
                type="text"
                value={fullname}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="e.g. Sarah Johnson"
              />
              {errors.fullname && (
                <p className="sam-error">{errors.fullname}</p>
              )}
            </div>

            {/* Email */}
            <div className="sam-form-group">
              <label className="sam-label">Email Address</label>
              <input
                className="sam-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="e.g. sarah@school.edu"
              />
              {errors.email && <p className="sam-error">{errors.email}</p>}
            </div>

            <div className="sam-form-group">
              <label className="sam-label">Password</label>
              <input
                className="sam-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
              />
              {errors.password && (
                <p className="sam-error">{errors.password}</p>
              )}
            </div>
{/*         
            <div className="sam-form-group">
              <label className="sam-label">Browser ID</label>
              <input
                className="sam-input"
                type="text"
                value={browserId}
                onChange={(e) => setBrowserId(e.target.value)}
                placeholder="Browser Id"
              />
              {errors.browserId && (
                <p className="sam-error">{errors.browserId}</p>
              )}
            </div> */}

            <div className="csm__form-group">
              <label className="csm__form-label">Department</label>
              <select
                className="csm__form-input"
                value={department}
                onChange={(e) => {
                  let selecteddepartmentfromdropdown = departments.find(
                    (dept) => dept.id == e.target.value,
                  );
                  setProgrammes(selecteddepartmentfromdropdown?.ngprogramme || []);
                  setDepartment(e.target.value);
                }}
              >
                <option value="0">SELECT DEPARTMENT</option>
                {departments.map((dept) => (
                  <option key={dept.id} value={dept.id}>{dept.deptName}</option>
                ))}
              </select>
            </div>

            <div className="csm__form-group">
              <label className="csm__form-label">Programme</label>
              <select
                className="csm__form-input"
                value={Programme}
                onChange={(e) => {
                  let selectedprogramfromdropdown = Programmes.find(
                    (prog) => prog.id == e.target.value,
                  );
                  setCourses(selectedprogramfromdropdown?.ngcourses || []);
                  setProgramme(e.target.value);
                }}
              >
                <option value="0">SELECT PROGRAMME</option>
                {Programmes.map((prog) => (
                  <option key={prog.id} value={prog.id}>{prog.progName}</option>
                ))}
              </select>
            </div>

            <div className="sam-form-group">
              <label className="sam-label">Courses</label>
              <div className="sam-checkbox-group">
                {courses.map((item) => (
                  <label key={item.id} className="sam-checkbox-item">
                    <input
                      type="checkbox"
                      value={item.id}
                      checked={selectedCourses.includes(item.id)}
                      onChange={() => handleCourseCheckbox(item.id)}
                    />
                    <span>{item.name}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Status */}
            <div className="sam-form-group">
              <label className="sam-label">Status</label>
              <select
                className="sam-input"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="Active">Active</option>
                <option value="Pending">Pending</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>

            <div className="sam-form-actions">
              {isSubmitting ? (
                <Spinner size="lg" />
              ) : (
                <button
                  className="sam-btn sam-btn-primary"
                  onClick={handleSubmit}
                >
                  Create Teacher
                </button>
              )}
              <button className="sam-btn sam-btn-secondary" onClick={onBack}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TeacherEdit = ({ teacher, onBack, onSave }) => {
  const { baseUrl } = useContext(AppContext);
  const [fullname, setFullName] = useState(teacher?.fullname || "");
  const [email, setEmail] = useState(teacher?.email || "");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState(teacher?.status || "Active");
  const [departments, setDepartments] = useState([]);
  const [Programmes, setProgrammes] = useState([]);
  const [department, setDepartment] = useState(teacher?.ngdepartment_id || "");

  const [Programme, setProgramme] = useState(teacher?.ngprogramme_id || "");
  const [courses, setCourses] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add/Update button spinner
  const [selectedCourses, setSelectedCourses] = useState(

    teacher?.ngteachercourses?.map(
      (item) => item.ngcourse.id
    ) || []

  );

  useEffect(()=>{

    axios
    .get(`${baseUrl}/admin/department/viewAllDepartments`)
    .then((response)=>{

        setDepartments(response.data.departments);

        const selectedDepartment =
        response.data.departments.find(
            d=>d.id==teacher.ngdepartment_id
        );

        if(selectedDepartment){

            setProgrammes(selectedDepartment.ngprogramme);

            const selectedProgramme =
            selectedDepartment.ngprogramme.find(
                p=>p.id==teacher.ngprogramme_id
            );

            if(selectedProgramme){

                setCourses(selectedProgramme.ngcourses);

            }

        }

    });

},[]);

  const handleCourseCheckbox = (courseId) => {
    setSelectedCourses((prev) =>
      prev.includes(courseId)
        ? prev.filter((id) => id !== courseId)
        : [...prev, courseId],
    );
  };

  const updateTeacher = () => {
    const formData = new FormData();
    formData.append("fullname", fullname);
    formData.append("email", email);
    formData.append("status", status);
    formData.append("ngdepartment_id", department);
    formData.append("ngprogramme_id", Programme);
    if (password) formData.append("password", password);
    selectedCourses.forEach((id) => formData.append("courses[]", id));

    setIsSubmitting(true);
    axios
      .post(`${baseUrl}/admin/user/updateTeacher/${teacher.id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        alert(response.data.message);
        if (onSave) onSave();
        if (onBack) onBack();
      })
      .catch((error) => {
        alert(error?.response?.data?.message || "Something went wrong");
      });
  };

  return (
    <div className="sam-wrapper">
      <div className="sam-container">
        <button className="sam-back-link" onClick={onBack}>
          &#8592; Back to List
        </button>
        <div className="sam-card">
          <div className="sam-page-header">
            <h2 className="sam-page-title">Edit Teacher</h2>
            <p className="sam-page-subtitle">
              Update the details for this teacher account.
            </p>
          </div>
          <hr className="sam-divider" />
          <div className="sam-form">
            {/* Full Name */}
            <div className="sam-form-group">
              <label className="sam-label">Full Name</label>
              <input
                className="sam-input"
                type="text"
                value={fullname}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Enter full name"
              />
            </div>

            {/* Email */}
            <div className="sam-form-group">
              <label className="sam-label">Email Address</label>
              <input
                className="sam-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email address"
              />
            </div>

            {/* Password */}
            <div className="sam-form-group">
              <label className="sam-label">Password</label>
              <input
                className="sam-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Leave blank to keep current password"
              />
            </div>
          
           
            <div className="csm__form-group">
              <label className="csm__form-label">Department</label>
              <select
                className="csm__form-input"
                value={department}
                onChange={(e) => {
                  let selecteddepartmentfromdropdown = departments.find(
                    (dept) => dept.id == e.target.value,
                  );
                  setProgrammes(selecteddepartmentfromdropdown?.ngprogramme || []);
                  setDepartment(e.target.value);
                }}
              >
                <option value="0">SELECT DEPARTMENT</option>
                {departments.map((dept) => (
                  <option key={dept.id} value={dept.id}>{dept.deptName}</option>
                ))}
              </select>
            </div>

            <div className="csm__form-group">
              <label className="csm__form-label">Programme</label>
              <select
                className="csm__form-input"
                value={Programme}
                onChange={(e) => {
                  let selectedprogramfromdropdown = Programmes.find(
                    (prog) => prog.id == e.target.value,
                  );
                  setCourses(selectedprogramfromdropdown?.ngcourses || []);
                  setProgramme(e.target.value);
                }}
              >
                <option value="0">SELECT PROGRAMME</option>
                {Programmes.map((prog) => (
                  <option key={prog.id} value={prog.id}>{prog.progName}</option>
                ))}
              </select>
            </div>

            <div className="sam-form-group">
              <label className="sam-label">Courses</label>
              <div className="sam-checkbox-group">
                {courses.map((item) => (
                  <label key={item.id} className="sam-checkbox-item">
                    <input
                      type="checkbox"
                      value={item.id}
                      checked={selectedCourses.includes(item.id)}
                      onChange={() => handleCourseCheckbox(item.id)}
                    />
                    <span>{item.name}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Courses */}
            {/* <div className="sam-form-group">
              <label className="sam-label">Courses</label>
              <div className="sam-checkbox-group">
                {courses.map((item) => (
                  <label key={item.id} className="sam-checkbox-item">
                    <input
                      type="checkbox"
                      value={item.id}
                      checked={selectedCourses.includes(item.id)}
                      onChange={() => handleCourseCheckbox(item.id)}
                    />
                    <span>{item.name}</span>
                  </label>
                ))}
              </div>
            </div> */}

            {/* Status */}
            <div className="sam-form-group">
              <label className="sam-label">Status</label>
              <select
                className="sam-input"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="Active">Active</option>
                <option value="Pending">Pending</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>

            <div className="sam-form-actions">
              <button
                className="sam-btn sam-btn-primary"
                onClick={updateTeacher}
              >
                Update Teacher
              </button>
              <button className="sam-btn sam-btn-secondary" onClick={onBack}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TeacherList = ({ onEdit, onAdd }) => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [teachers, setTeachers] = useState([]);

  const viewAllTeachers = () => {

    axios
      .get(`${baseUrl}/admin/user/viewAllTeachers`)
      .then((response) => {
        console.log(
          "this is log from the get all teachers function",
          response.data,
        );
        setTeachers(response.data.teachers);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    viewAllTeachers();
  }, []);

  const deleteTeacher = (id) => {
    if (!window.confirm("Are you sure you want to delete this teacher?"))
      return;
    const formData = new FormData();
    formData.append("id", id);
    axios
      .post(`${baseUrl}/admin/user/deleteTeacher`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        alert(response.data.message);
        viewAllTeachers();
      })
      .catch((error) => {
        alert(error?.response?.data?.message || "Something went wrong");
      });
  };

  return (
    <div className="sam-wrapper">
      <div className="sam-container">
        <div className="sam-card">
          <div className="sam-flex-between sam-page-header">
            <div>
              <h2 className="sam-page-title">Teacher List</h2>
              <p className="sam-page-subtitle">Manage all teacher accounts.</p>
            </div>
            <button className="sam-btn sam-btn-primary" onClick={onAdd}>
              + Add Teacher
            </button>
          </div>
          <hr className="sam-divider" />
          <div className="sam-table-wrapper">
            <table className="sam-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th>Department</th>
                  <th>Programme</th>
                  <th>Courses</th>
                  <th>Status</th>
                  <th>QR Code</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {teachers.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="sam-empty">
                      No teachers found.
                    </td>
                  </tr>
                ) : (
                  teachers.map((teacher) => (
                    <tr key={teacher.id}>
                      <td>
                        <span className="sam-id-badge">{teacher.id}</span>
                      </td>
                      <td>{teacher.fullname}</td>
                      <td>{teacher.email}</td>
                      
                      {/* FIX: Department and Programme were swapped, qr_code was showing in Department column */}
                      <td className="sam__table-cell">
                        {teacher.ngdepartment?.deptName || "—"}
                      </td>
                      <td className="sam__table-cell">
                        {teacher.ngprogramme?.progName || "—"}
                      </td>
                      <td>
                        {teacher.ngteachercourses?.length > 0
                          ? teacher.ngteachercourses.map((course) => (
                            <Badge
                              key={course.id}
                              bg="primary"
                              className="me-1 mb-1"
                            >
                              {course.ngcourse.name}
                            </Badge>
                          ))
                          : "—"}
                      </td>
                      <td>{teacher.status}</td>
                      {/* QR Code: show as image if path exists, else show dash */}
                      <td>
                        {teacher.qr_code ? (
                          <img
                            src={`${baseUrlForFiles}/${teacher.qr_code}`}
                            alt="QR Code"
                            style={{ width: "60px", height: "60px" }}
                          />
                        ) : (
                          "—"
                        )}
                      </td>
                      <td>
                        <div className="sam-table-actions">
                          <button
                            className="sam-btn sam-btn-edit"
                            onClick={() => onEdit(teacher)}
                          >
                            Edit
                          </button>
                          <button
                            className="sam-btn sam-btn-danger"
                            onClick={() => deleteTeacher(teacher.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const TeacherManagement = () => {
  const [currentView, setCurrentView] = useState("list");
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const handleAdd = () => setCurrentView("add");

  const handleEdit = (teacher) => {
    setSelectedTeacher(teacher);
    setCurrentView("edit");
  };

  const handleBack = () => {
    setCurrentView("list");
    setSelectedTeacher(null);
  };

  return (
    <Adminmasterlayout>
      <div>
        {currentView === "list" && (
          <TeacherList onAdd={handleAdd} onEdit={handleEdit} />
        )}
        {currentView === "add" && (
          <TeacherAdd onBack={handleBack} onSave={handleBack} />
        )}
        {currentView === "edit" && (
          <TeacherEdit
            teacher={selectedTeacher}
            onBack={handleBack}
            onSave={handleBack}
          />
        )}
      </div>
    </Adminmasterlayout>
  );
};

export default TeacherManagement;